// extracted by mini-css-extract-plugin
export var catList = "JobPostings-module--cat-list--89778";
export var category = "JobPostings-module--category--4889b";
export var heading = "JobPostings-module--heading--298c2";
export var hr = "JobPostings-module--hr--510b2";
export var job = "JobPostings-module--job--996e6";
export var location = "JobPostings-module--location--46f48";
export var team = "JobPostings-module--team--fbe6a";
export var title = "JobPostings-module--title--2b627";